import React, { Component } from 'react';
import { firebaseAuth, base, shirtTypes, shirtCollars } from '../../config/constants.js'
import { Form, Input, Grid, Label, Divider, Button } from 'semantic-ui-react'
import Select from 'react-select';
import { FootballFormParts, ShowJerseyImage } from './football/FootballFormParts'
import { TemplateMonths } from './templates/TemplateFormParts'

export default class SizeAndQtyFields extends Component {
    constructor(props) {
        super(props);

        this.state = {
            shirtSizes: [],
            shirtColors: [],
            shirtSizesSele: [],
            shirtColors: [],
            shirtTypes: [],
            cranesColors: [],
            options: [
                { value: 'one', label: 'One' },
                { value: 'two', label: 'Two' },
                { value: 'three', label: 'Three' }
            ],
            shirtColor: '',
            shirtSize: '',
        }
    }


    componentDidMount() {

        //SHIRT SIZES
        base.fetch('shirtSizesSele', {
            context: this,
            asArray: true,
            state: 'shirtSizesSele',
            then(data) {
                //  console.log(data);
                this.setState({
                    shirtSizesSele: data
                })
            }
        });

        //SHIRT COLORS
        base.fetch('shirtColors', {
            context: this,
            asArray: true,
            state: 'shirtColors',
            then(data) {
                //  console.log(data);
                this.setState({
                    shirtColors: data
                })
            }
        });


        //CRANES SHIRT COLORS
        base.fetch('cranes/cranesColors', {
            context: this,
            asArray: true,
            then(data) {
               // console.log("cranes colors xxc");
                 console.log(JSON.stringify(data,null,3));

                // this.setShirtColors(data);

                this.setState({
                    cranesColors: data
                })
            }
        });

        //SHIRT TYPES
        this.setShirtTypes();
        // base.fetch('shirtTypes', {
        //     context: this,
        //     asArray: true,
        //     state: 'shirtTypes',
        //     then(data) {
        //         // console.log(data);
        //         this.setState({
        //             shirtTypes: data
        //         })
        //     }
        // });

    }

    setShirtTypes = (itemType) => {

        if (itemType !== 'jumper') {
            this.setState({
                shirtTypes: shirtCollars
            })
        } else {
            this.setState({
                shirtTypes: shirtTypes
            })
        }

    }

    setShirtColors = (sentShirtColors) => {

        if (this.props.itemSelected === 'cranes') {
            // console.log("its cranes..loading cranes colors");
            this.setState({
                shirtColors: sentShirtColors
            })

        } else if (this.props.itemSelected === 'football') {
            // console.log("its cranes..loading cranes colors");
            this.setState({
                shirtColors: this.props.selectedTeamColors
            })
        } else {
            // console.log("item is NOT CRANES - nothing");
        }
    }

    handleAddMoreClick = () => {
        // console.log("++++++:handleAddMoreClick");
        this.props.handleAddMoreClick(this.props.topDividerText);
    }

    render() {

        const templateSelectMonthField = this.props.monthTemplate ? (
            <TemplateMonths
                monthSelected={this.props.monthSelected}
                handleOrderDetailsDropDownChanges={this.props.handleOrderDetailsDropDownChanges} />
        ) : ''

        /**
         * DEPENDING OF ITS A MONTH SELECTED OR NOT THE SPECIEL FIELD WILL BE MONTH DROP DOWN OR NOT..
         */
        const templateGenericField = this.props.selectDateTemplate
            ? <div>
                <Label pointing='below' color='blue'>{this.props.templateSpecialFieldLabel}</Label>
                <Form.Field
                    name={this.props.templateGenericFieldName}
                    value={this.props.templateGenericField}
                    control={Input}
                    placeholder={this.props.templateSpecialFieldLabel}
                    onChange={this.props.handleTextInputChange}
                    error={this.props.formErrorFieldArray[this.props.templateGenericField]} />
            </div>
            : ''

        /**
         * SHIRT SIZE IF SHOWN FOR EVERYTHING EXCEPT CUPS -- ORIGINAL
         */
        const shirtSize = this.props.itemSelected !== 'cup' &&  this.props.itemSelected !== 'pillow'
            ? <Grid.Column>
                {/* SHIRT SIZE */}
                <Label pointing='below' color='blue'>{this.props.shirtSize !== '' ? this.props.shirtSize : 'SHIRT SIZE'}</Label>
                <Select
                    name="form-field-name"
                    value={this.props.shirtSize}
                    //value={'medium'}
                    //options={this.state.shirtSizesSele}
                    options={this.props.shirtSizes}
                    onChange={this.props.handleOrderDetailsDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
            </Grid.Column>
            : ''

        const itemColor = this.props.itemSelected === 'cup'  || this.props.itemSelected === 'pillow'
            ? <Grid.Column>
                {/* CUP COLOR */}
                <Label pointing='below' color='blue'>{'CUP COLOR'}</Label>
                <Select
                    name="form-field-name"
                    value={this.props.shirtColor}
                    options={this.props.shirtColors}
                    onChange={this.props.handleOrderDetailsDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
            </Grid.Column>
            : <Grid.Column>
                {/* SHIRT COLOR */}
                <Label pointing='below' color='blue'>{this.props.shirtColor !== '' ? this.props.shirtColor : 'SHIRT COLOR'}</Label>
                <Select
                    name="form-field-name"
                    value={this.props.shirtColor}
                    options={this.props.shirtColors}
                    onChange={this.props.handleOrderDetailsDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
            </Grid.Column>

        const firstRow = (
            <Grid columns='equal'>

                {/* SHIRT SIZE */}
                {shirtSize}

                {itemColor}
            </Grid>
        )

        /**
         * THE SHIRT TYPE DOES NOT APPEAR FOR CRANES SHIRTS..
         */
        const shirtTypeColumn = this.props.itemSelected === 't-shirts'
            ? <Grid.Column >
                {/* SHIRT TYPE */}
                <Label pointing='below' color='blue'>{this.props.shirtType !== '' ? this.props.shirtType : 'SHIRT COLLAR'}</Label>
                <Select
                    name="form-field-name"
                    value={this.props.shirtType}
                    options={this.state.shirtTypes}
                    onChange={this.props.handleOrderDetailsDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
            </Grid.Column>
            : <br />


        /**
         * SHOW THE CHILDS AGE WHEN BABY IS SELECTED
         */
        const childsAge = this.props.shirtSize === 'baby' ? (
            <Grid.Column >
                {/* BABYS AGE */}
                <Label pointing='below' color='blue'>CHILD'S AGE</Label>
                <Form.Field
                    name={this.props.childsAgeTextFeildName}
                    value={this.props.childsAge}
                    control={Input}
                    type='number' max={1000} 
                    min="1"
                    placeholder={'Child Age'}
                    onChange={this.props.handleTextInputChange}
                    error={this.props.formErrorFieldArray[this.props.childsAgeTextFeildName]} />
            </Grid.Column>
        )
            : ''

        const secondRow = (
            <Grid columns='equal'>

                {shirtTypeColumn}

                {/* INPUT FOR CHILDS AGE */}
                {childsAge}

                <Grid.Column >
                    {/* SHIRT qty */}
                    <Label pointing='below' color='blue'>QUANTITY</Label>
                    <Form.Field
                        name={this.props.qtyTextFeildName}
                        value={this.props.qty}
                        control={Input}
                        type='number' max={1000}
                        placeholder={'Quantity'}
                        onChange={this.props.handleTextInputChange}
                        error={this.props.formErrorFieldArray[this.props.qtyTextFeildName]} />
                </Grid.Column>
            </Grid>
        )

        const topDivider = (
            <div>
                <Divider horizontal>{this.props.topDividerText}</Divider>
                Contact us at 0757477399 (whatsapp) if you have issue with placing your order
                <br />
            </div>

        )

        /**
         * JERSEY NUMBER
         */
        const jerseyNumber = (this.props.itemSelected === 'cranes' || this.props.itemSelected === 'football' ?
            <div>
                <Label pointing='below' color='blue'>What number on the back of your Jersey?</Label>

                <Form.Field
                    name={this.props.jerseyNumberFieldName}
                    value={this.props.jerseyNumber}
                    control={Input}
                    length='2'
                    placeholder={'Jersey Number'}
                    onChange={this.props.handleTextInputChange}
                    error={this.props.formErrorFieldArray[this.props.jerseyNumberFieldName]} />
                {/* <label>{'** NOTICE - There is a extra charge of 5,000 for numbers'}</label> */}
            </div>
            : ""
        )

        /**
        * JERSEY NAME
        */
        const jerseyName = (this.props.itemSelected === 'cranes' || this.props.itemSelected === 'football' ?
            <div>
                <br />
                <Label pointing='below' color='blue'>What name on the back of your Jersey?</Label>
                <Form.Field
                    name={this.props.jerseyNameFieldName}
                    value={this.props.jerseyName}
                    control={Input}
                    length='2'
                    placeholder={'Jersey Name'}
                    onChange={this.props.handleTextInputChange}
                    error={this.props.formErrorFieldArray[this.props.jerseyNameFieldName]} />
            </div>
            : ""
        )

        /**
      * SHOW PARTS FOR FOOTBALL FORM..
      */
        const footBallTeam = this.props.itemSelected === 'football'
            ? <FootballFormParts
                teamSelection={this.props.teamSelection}
                handleFootballDropDownChange={this.props.handleOrderDetailsDropDownChanges}
                handleTextInputChange={this.props.handleTextInputChange}
                typedInTeamName={this.props.typedInTeamName}
                typedInTeamNameFieldName={this.props.typedInTeamNameFieldName} />
            : ''

        const mainUi = (
            <div>

                {topDivider}

                {/* FIRST ROW */}
                {firstRow}

                {/* SECOND ROW */}
                {secondRow}

                <br />
                If you need different sizes and colors e.g (2) Blue Large (1) Small Green
                <Button color='green' content='Add More Quantities And Colors' icon='plus cart' labelPosition='left' />
            </div>
        )

        let showButton = false;

        if ((this.props.topDividerText === 'Order 1' || this.props.topDividerText.includes('Order ARRAY')) && !this.props.order2Visible) {
            showButton = true;

        } else if (this.props.topDividerText === 'Order 2' && !this.props.order3Visible) {
            showButton = true;

        } else {
            showButton = false;
        }

        const moreButton = showButton
            ? (
                <div>
                    <br />
                    <Button type='Button' onClick={this.handleAddMoreClick}
                        color='green' content='Add More Quantities And Colors'
                        icon='plus' labelPosition='left' />
                </div>
            )
            : (<br />)

        const showIfVisible = this.props.visible
            ? (<div>
                {topDivider}

                {/* WHEN MONTH IS SELECTED */}
                {templateSelectMonthField}

                {/* GENERIC TEXT FIELD TO TEMPLATE */}
                {templateGenericField}

                {/* FOOTBALL team */}
                {footBallTeam}

                {/* JERSEY NAME */}
                {jerseyName}

                {/* JERSEY NUMBER */}
                {jerseyNumber}

                {/* FIRST ROW */}
                {firstRow}

                <ShowJerseyImage
                    teamSelection={this.props.teamSelection}
                    itemSelected={this.props.itemSelected}
                    shirtColor={this.props.shirtColor}
                    selectedTeamColors={this.props.selectedTeamColors} />

                {/* SECOND ROW */}
                {secondRow}

                {/* MORE BUTTON */}
                {moreButton}

            </div>)
            : (<p></p>)

        return (
            <div>
                {showIfVisible}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/newSite/SizeAndQtyFields.js